// Frontend-only display label maps (Spanish).
// Backend keys remain in English and are never mutated here.

export const QUEUE_LABEL_ES = {
  remittance_assigned_to_me:    'Remesas asignadas a mí',
  pending_payment_review:       'Revisión de pagos pendientes',
  awaiting_provider_assignment: 'Asignación de proveedor pendiente',
  awaiting_ticket_processing:   'Tickets a procesar',
  pending_document_review:      'Revisión de documentos',
};

export const queueLabelEs = (name) =>
  QUEUE_LABEL_ES[name] || (name ? name.replace(/_/g, ' ') : '');

export const OP_TYPE_LABEL_ES = {
  remittance: 'Remesa',
  ticket:     'Ticket',
};

export const opTypeLabelEs = (t) =>
  OP_TYPE_LABEL_ES[t] || (t ? t.charAt(0).toUpperCase() + t.slice(1) : '');

export const PROVIDER_STATUS_LABEL_ES = {
  active:   'activo',
  paused:   'pausado',
  inactive: 'inactivo',
};

export const providerStatusLabelEs = (s) => PROVIDER_STATUS_LABEL_ES[s] || s || '';

export const AVAILABILITY_LABEL_ES = {
  available: 'disponible',
  busy:      'ocupado',
  offline:   'desconectado',
};

export const availabilityLabelEs = (a) => AVAILABILITY_LABEL_ES[a] || a || '';

export const DOC_VERIFICATION_LABEL_ES = {
  PENDING:  'PENDIENTE',
  VERIFIED: 'VERIFICADO',
  REJECTED: 'RECHAZADO',
};

export const docVerificationLabelEs = (s) => DOC_VERIFICATION_LABEL_ES[s] || s || '';
